import axios from 'axios'

const BASE_URL = "https://storage.googleapis.com/mlr-demo-question-answering-texts"
const TEXT_URL = BASE_URL + "/current.txt"


class TextsResource {
    
    getTextAnd(consumer) {
        // Return the object to possibly handle the error
        return axios.get(TEXT_URL)
            .then(response => consumer(response.data))
    }

}

const textsApi = new TextsResource()

export default textsApi
